import { render, staticRenderFns } from "./ReleaseNames.vue?vue&type=template&id=085c8a65&scoped=true&"
import script from "./ReleaseNames.vue?vue&type=script&lang=js&"
export * from "./ReleaseNames.vue?vue&type=script&lang=js&"
import style0 from "./ReleaseNames.vue?vue&type=style&index=0&id=085c8a65&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "085c8a65",
  null
  
)

export default component.exports